import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useTruckerProps } from 'hooks/useTruckerProps';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import { getTrucker } from 'services/truckerProfile';

export const TRUCKER_PROFILE_KEY = 'trucker-profile-key';

export const useTruckerProfileQuery = (options?: Partial<UseQueryOptions<ITruckerProfileProps, Error>>) => {
  const { truckerId, freightId } = useTruckerProps();

  return useQuery<ITruckerProfileProps, Error>({
    queryKey: [TRUCKER_PROFILE_KEY, truckerId],
    queryFn: () => getTrucker(truckerId, freightId),
    enabled: !!truckerId,
    retry: false,
    gcTime: 0,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    ...options,
  });
};
